// extracted by mini-css-extract-plugin
export default {"list":"AttributeList_list__nvhSY"};